import React, { useEffect, useState } from "react";
import Title from "../../components/common/Title";
import { Topbar } from "../../components/include/Topbar";
import { useNavigate } from "react-router-dom";
import { EyeIcon } from "@heroicons/react/20/solid";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import { useDispatch, useSelector } from "react-redux";
import { message } from "../../redux/actions/toastActions";
import Page from "../../helpers/config";
import Pagination from "../../components/common/Pagination";
import DeleteModal from "../../components/common/DeleteModal";
import { isPermission, isRole, isRoleType } from "../../redux/selectors/authSelector";
import Error403Page from "../ErrorPage";
import { useCountryNavigate } from "../../components/common/UseCountryNavigate";
import axios from "axios";
import { toast } from "sonner";

const ParentList = () => {
  const [data, setData] = useState([]);
  const navigate = useCountryNavigate();
  const dispatch = useDispatch();
  const [refresh, setRefresh] = useState(false);
  const [loader, setLoader] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(Page.records);
  const [currentPage, setCurrentPage] = useState(1);
  const [modalOpenDelete, setModalOpenDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [modalOpenDeleteSuccess, setModalOpenDeleteSuccess] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [hasFetched, setHasFetched] = useState(false);
  const permissions = useSelector(isPermission);
  const role = useSelector(isRole);
  const role_type = useSelector(isRoleType);
  const mode = localStorage.getItem("mode")
  const isAccessible = role === "admin" || role === "subadmin" || role === "schooladmin" || (permissions && (permissions?.includes("view_Parent") || permissions?.includes("view_School")));
  const isEditable = role === "admin" || role === "subadmin" || role === "schooladmin" || (permissions && (permissions?.includes("edit_Parent") || permissions?.includes("edit_School")));
  const isDeletable =
    role === "admin" || role === "subadmin" || role === "schooladmin" || (permissions && (permissions?.includes("delete_Parent") || permissions?.includes("delete_School")));
  const schoolId = localStorage.getItem("activeSchoolId");
  // useEffect(() => {
  //   const fetchSearchResults = async () => {
  //     setLoader(true);
  //     try {
  //       Postdata(HttpService.parent_list, {
  //         search: searchQuery,
  //         school_id: schoolId,
  //       }).then((res) => {
  //         if (res.status === 200) {
  //           setData(res.data.parents);
  //           setTotalRows(res.data.count);
  //         }
  //       });
  //     } catch (error) {
  //       console.error("Error fetching search results:", error);
  //     } finally {
  //       setLoader(false);
  //     }
  //   };

  //   const timer = setTimeout(() => {
  //     fetchSearchResults();
  //   }, 500); // Debounce the search to only trigger after 500ms

  //   return () => clearTimeout(timer); // Cleanup timer on component unmount or change in searchQuery
  // }, [searchQuery]);

  // Pagination handlers
  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchData(page, perPage);
  };

  const handleRowsPerPageChange = (rows) => {
    setPerPage(rows);
    setCurrentPage(1);
    fetchData(1, rows);
  };

  // Handle delete functionality
  const handleDelete = async (id) => {
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_API_URL}admin/parent-delete/${id}`
      );

      if (res.data.status === 200) {
        toast.success("Parent deleted successfully");
        fetchData();
      }
    } catch (error) {
      toast.error("Failed to delete parent");
    }
  };


  // Toggle parent status (active/inactive)
  const handleStatusToggle = (id) => {
    setData((prevData) =>
      prevData.map((item) =>
        item._id === id
          ? { ...item, is_deleted: !item.is_deleted }
          : item
      )
    );
  };

  // Fetch parents data
  const fetchData = async () => {
    setLoader(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}admin/parent-list`,
        {
          page: currentPage,
          perpage: perPage,
          search: searchQuery,
          school_id: schoolId,
        }

      );
      console.log("parent", res);

      if (res.data.status === 200) {
        setData(res.data.data.parents);
        setTotalRows(res.data.data.count);
        setHasFetched(true);
      }
    } catch (error) {
      console.error("Error fetching parents", error);
    } finally {
      setLoader(false);
    }
  };


  useEffect(() => {
    fetchData(currentPage, perPage);
  }, [refresh, currentPage, perPage]);

  if (!isAccessible) {
    return <Error403Page />;
  }

  return (
    <>
      <Title name="Parent List" />
      <Topbar title="Parent List" />
      <div className="p-6 space-y-6 pr-0">
        <div className=" flex justify-end">
          <input
            type="text"
            placeholder="Search parents, email, phone..."
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
            }}
            className="px-4 py-2 mr-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none w-72"
          />
          <div className="">
            {isEditable && role !== "admin" && (
              <button
                className="bg-primary_main text-white px-4 py-2 rounded hover:bg-primary_dark"
                onClick={() => navigate("parent-add")}
              >
                + Add Parent
              </button>
            )}
          </div>
        </div>
        <div className="bg-white rounded overflow-x-auto p-2">
          <table className="min-w-full text-sm text-left">
            <thead className="text-gray-700">
              <tr>
                <th className="px-6 py-3 font-medium">Name</th>
                <th className="px-6 py-3 font-medium">Email</th>
                <th className="px-6 py-3 font-medium">Phone</th>
                {isEditable && role !== "admin" && (
                  <th className="px-6 py-3 font-medium">Status</th>
                )}
                <th className="px-6 py-3 font-medium">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {loader || !hasFetched ? (
                <tr>
                  <td colSpan="5" className="text-center py-4">
                    <div className="loader">Loading...</div>
                  </td>
                </tr>
              ) : (
                data.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-6 py-4">{item.name}</td>
                    <td className="px-6 py-4">{item.email}</td>
                    <td className="px-6 py-4">{item.mobile_number || "-"}</td>
                    {isEditable && role !== "admin" && (
                    <td className="px-6 py-4">
                      {isEditable ? (
                        <label className="inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            className="sr-only peer"
                            checked={!item.is_deleted}
                            onChange={() => handleStatusToggle(item._id)}
                          />
                          <div
                            className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary_main rounded-full peer
                                                        peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px]
                                                        after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all
                                                        peer-checked:bg-primary_main"
                          ></div>
                        </label>
                      ) : item.status === 1 ? (
                        "Active"
                      ) : (
                        "Inactive"
                      )}
                    </td>
                    )}
                    <td className="px-6 py-4 space-x-3">
                      <button
                        className="text-black hover:underline"
                        onClick={() => {
                          // localStorage.setItem("mode", "view");
                          navigate(`parent-view/${item._id}`);
                        }}
                      >
                        View
                      </button>
                      {isEditable && role !== "admin" && (
                        <button
                          className="text-primary_main hover:underline"
                          onClick={() => {
                            // localStorage.removeItem("mode");
                            navigate(`parent-edit/${item._id}`, {
                              state: { type: "edit" },
                            });
                          }}
                        >
                          Edit
                        </button>
                      )}
                      {isDeletable && role !== "admin" && (
                        <button
                          className="text-red-600 hover:underline"
                          onClick={() => {
                            setSelectedId(item._id);
                            setModalOpenDelete(true);
                          }}
                        >
                          Delete
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {!loader && data !== null && hasFetched && data.length === 0 && (
            <div className="h-[50vh] flex items-center justify-center w-full">
              <h1 className="text-center text-gray-400">No Data Found</h1>
            </div>
          )}
        </div>

        <Pagination
          currentPage={currentPage}
          totalRows={totalRows}
          perPage={perPage}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          type=""
        />

        <DeleteModal
          title="Delete Parent"
          message="Are you sure you want to delete Parent? It will erase all the data permanently."
          modalOpenDelete={modalOpenDelete}
          setmodalOpenDelete={setModalOpenDelete}
          handleDelete={handleDelete}
          selectedId={selectedId}
          setSelectedId={setSelectedId}
          modalOpenDeleteSuccess={modalOpenDeleteSuccess}
          setModalOpenDeleteSuccess={setModalOpenDeleteSuccess}
          module={"Parent"}
          redirectPage={"Parent Management"}
          // redirectUrl={"parent-management"}
          redirectUrl={
            mode === "view"
              ? `admin-school/view/${schoolId}`
              : role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin"
                ? "navigation-dashboard"
                : "parent-management"
          }
          redirectState={
            role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin" ? { mainTab: "Parents Management" } : undefined
          }
        />
      </div>
    </>
  );
};

export default ParentList;